
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[category]",
      function () {
        return require("private-next-pages/articles/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[category]"])
      });
    }
  